<div class="container">
  <mat-card>
    <mat-card-content fxFlex fxLayout="center" fxLayoutAlign="center center">
      <form fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="10px">
        <mat-form-field>
          <input matInput placeholder="Theme name" [formControl]="themeName" type="text">
          <mat-error *ngIf="themeName.hasError('required')">
            Theme name is required.
          </mat-error>
        </mat-form-field>
        <button class="w-100" mat-flat-button color="primary" (click)="addTheme()">Create</button>
      </form>
    </mat-card-content>
  </mat-card>
</div>